/**
 * Maps PageHero badge labels to in-app routes or access-request modals.
 * Labels are matched case-insensitively after trimming.
 */

/** Badges that open the access-request popup (name, mobile, email). */
export const accessRequestBadges = new Set([
  'strategic advisory',
  'resilience advisory',
  'executive briefings',
  'research',
  'briefings',
]);

export const badgeLinks = {
  'aera™': '/framework',
  aera: '/framework',
  'aera™ aligned': '/framework',
  'resilience engineering': '/who-we-are#resilience-engineering',
  anticipate: '/framework#anticipate',
  assess: '/framework#assess',
  architect: '/framework#architect',
  activate: '/framework#activate',
  advance: '/framework#advance',
  manufacturing: '/industries/manufacturing',
  healthcare: '/industries/healthcare',
  bfsi: '/industries/financial-services',
  technology: '/industries/technology',
  'risk intelligence': '/capabilities/enterprise-risk-intelligence',
  'protection architecture': '/capabilities/insurance-architecture',
  continuity: '/capabilities/business-continuity',
  'strategic capability': '/capabilities',
  'sector resilience': '/industries',
  ai: '/technology#ai',
  qrify: '/technology#qrify',
  'svasth.ai': '/technology#svasth',
  monitoring: '/technology#monitoring',
  frameworks: '/framework',
  'all-risk-point': '/erm-efficiency-index',
  'proprietary index': '/erm-efficiency-index',
  'board-ready': '/erm-efficiency-index#erm-scorecard',
  'irda licensed': '/who-we-are',
  'since 2002': '/who-we-are',
  'foreseeing risks': '/who-we-are',
  '30+ years experience': '/leadership',
  '30+ years': '/leadership',
  'ph.d leadership': '/leadership',
  'gold star award': '/leadership',
  'strategic vision': '/leadership',
};

const normalizeLabel = (label) => String(label || '').trim().toLowerCase();

export const isAccessRequestBadge = (label) =>
  accessRequestBadges.has(normalizeLabel(label));

export const getBadgeLink = (label) => {
  const key = normalizeLabel(label);
  if (!key || accessRequestBadges.has(key)) return null;
  return badgeLinks[key] || null;
};

/**
 * @returns {{ type: 'access' | 'link' | 'none', to?: string, topic?: string }}
 */
export const getBadgeAction = (label) => {
  const key = normalizeLabel(label);
  if (!key) return { type: 'none' };
  if (accessRequestBadges.has(key)) {
    return { type: 'access', topic: String(label).trim() };
  }
  const to = badgeLinks[key];
  if (to) return { type: 'link', to };
  return { type: 'none' };
};
